// Pure helper for the "which top-nav entry should be active?" check.
// Default NavLink isActive only compares pathname, but all four /ropas
// entries (Nuevo, Destacados, FW2026, Esenciales) share that pathname —
// only the query string differentiates them. Extracted so the rule is
// testable without mounting Navigation.

/**
 * @param pathname   current location.pathname (e.g. "/ropas")
 * @param search     current location.search   (e.g. "?filter=nuevo")
 * @param target     {filter?, orden?, categoria?, exactBase?}
 *
 *   - filter / orden / categoria:
 *       exact-string match against the same-named URL param. Provide ONLY
 *       the key(s) your entry cares about — others are ignored.
 *   - exactBase=true:
 *       match only when none of the three top-nav keys is present in the
 *       URL. Used by the "plain /ropas" (FW2026) entry so it doesn't light
 *       up alongside Nuevo / Destacados / Esenciales.
 *
 * @returns boolean
 */
export function isRopasNavActive(pathname, search, target = {}) {
  if (pathname !== '/ropas') return false;
  const params = new URLSearchParams(search || '');
  const { filter, orden, categoria, exactBase = false } = target;

  if (exactBase) {
    return !params.get('filter') && !params.get('orden') && !params.get('categoria');
  }
  if (filter !== undefined && params.get('filter') !== filter) return false;
  if (orden !== undefined && params.get('orden') !== orden) return false;
  if (categoria !== undefined && params.get('categoria') !== categoria) return false;
  return true;
}
